// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1jp5n","addWidgetButton":"Header_addWidgetButton__1IptR","dashboardTabs":"Header_dashboardTabs__3vEJq","active":"Header_active__22PoK"};